import http from '../_http'

const userWsfinder = {
  //default
  summaryUser: (m) => { return http.get(`manager/wsfinder/user`, m); },
  listUser: (m) => { return http.post(`manager/wsfinder/user/list`, m); },
  detailUser: (m) => { return http.get(`manager/wsfinder/user/${m.id}`); },

  //crud
  insertUser: (m) => { return http.post(`manager/wsfinder/user`, m); },
  updateUser: (m) => { return http.put(`manager/wsfinder/user`, m); },
  deleteUser: (m) => { return http.delete(`manager/wsfinder/user/${m.id}`); },
}

export default userWsfinder

export { userWsfinder }